// extracted by mini-css-extract-plugin
module.exports = {"root":"FooterSocials_root__eDsC_","social":"FooterSocials_social__7NnPf","filler":"FooterSocials_filler__MxXAh","socialItem":"FooterSocials_socialItem__HBI0n"};